import{__require as r}from"./to-integer-or-infinity.js";var i,n;function t(){if(n)return i;n=1;var t=r(),e=Math.min;return i=function(r){var i=t(r);return i>0?e(i,9007199254740991):0}}export{t as __require};
//# sourceMappingURL=to-length.js.map
